/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { voterAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type ResetProps = {
  account: Address
  chainId: number
  config: Config
  voterAddress: Address
  tokenId: number
}

export const reset = async ({
  account,
  chainId,
  config,
  voterAddress,
  tokenId,
}: ResetProps): Promise<TransactionReturnType> => {
  const result = await simulatedTransaction({
    config,
    simulateArgs: {
      abi: voterAbi as Abi,
      account,
      address: voterAddress,
      args: [tokenId],
      chainId,
      functionName: "reset",
    },
  })
  return result
}

/*
const reset = async ({ web3, tokenId, account, gasPrice, voterAddress }) => {
  try {
    const options = { from: account }
    if (gasPrice) {
      options["gasPrice"] = gasPrice
    }
    const VoterContract = new web3.eth.Contract(voterAbi, voterAddress)
    const tx = await VoterContract.methods.reset(tokenId).send(options)
    return { tx, success: true }
  } catch (error: any) {
    console.error("reset", error)
    // @ts-ignore
    return { tx: null, success: false, error: error.message, code: error.code }
  }
}
*/
